import { LocalShoppingItemsData } from './local-shopping-items-data';
import { RecipeData } from '../../recipes/providers/recipe-data';
import { Injectable } from '@angular/core';
import { FireBaseObjectNames } from '../../../core/codes';
import { AngularFireDatabaseWrapper } from '../../../providers/angularfire-wrapper';
@Injectable()
export class UserShoppingItemsData {
    constructor(public afw: AngularFireDatabaseWrapper,
        public recipeData: RecipeData,
        public localShoppingItemsData: LocalShoppingItemsData
    ) {

    }
    public get(userId) {

        let strgRef = FireBaseObjectNames.SHOPPING_ITEMS + '/' + userId;
        console.log(strgRef);
        return this.afw.object(strgRef);
    }
    public add(userId, item) {
        console.log("add list item: ");
        console.log(item);
        
        return new Promise((resolve, reject) => {
            let strgRef = FireBaseObjectNames.SHOPPING_ITEMS + '/' + userId,
                ref = this.afw.list(strgRef);
            let key = ref.push(item).key;
            item['$key'] = key;
            this.localShoppingItemsData.add(userId, key, item);
            this.recipeData.updateTimeStampModified(strgRef);
            return resolve(item);
        });
    }
    public remove(userId, itemKey) {
        return new Promise((resolve, reject) => {
            let timestampRef = FireBaseObjectNames.SHOPPING_ITEMS + '/' + userId,
                strgRef = FireBaseObjectNames.SHOPPING_ITEMS + '/' + userId + '/' + itemKey,
                ref = this.afw.object(strgRef);
                console.log(strgRef);
            ref.remove().then(()=>{
                this.localShoppingItemsData.remove(userId, itemKey);
                this.recipeData.updateTimeStampModified(timestampRef);      
            });
            return resolve(true);
        });
    }
    public updateIsGotItem(userId, item, isGot) {
        return new Promise((resolve, reject) => {
            let timestampRef = FireBaseObjectNames.SHOPPING_ITEMS + '/' + userId,
                strgRef = FireBaseObjectNames.SHOPPING_ITEMS + '/' + userId + '/' + item.$key,
                ref = this.afw.object(strgRef);
            ref.update({ isGot: isGot });
            this.recipeData.updateTimeStampModified(timestampRef);
            return resolve(true);
        });
    }

}


// WEBPACK FOOTER //
// ./src/modules/account/providers/user-shopping-items-data.ts